// export default {
//   apiKey: 'AIzaSyAcSHG9cVqVExOjng4rBbr_Lller6mM_cc',
//   authDomain: 'restaurant-app-3a7b0.firebaseapp.com',
//   databaseURL: 'https://restaurant-app-3a7b0.firebaseio.com',
//   projectId: 'restaurant-app-3a7b0',
//   storageBucket: 'restaurant-app-3a7b0.appspot.com',
//   messagingSenderId: '372669475230',
//   appId: '1:372669475230:web:883ac63fa3085e22'
// }
// {
//   'type': 'service_account',
//   'project_id': 'transit-1538616739451',
//   'private_key_id': 'a1c23152dd9d18c07c6617eac140bfc484473f33',
//   'private_key': '-----BEGIN PRIVATE KEY-----\nMIIEvQIBADANBgkqhkiG9w0BAQEFAASCBKcwggSjAgEAAoIBAQDPQDpkmCFbL9YA\nH2wa4al3nYu65DTY+Pgyid55LugifrZZ/Pr4US74DosilTXFZGv5GwF4sh8ook+e\njAyltFPoKtUMhlDn/Cem7aaw7Xtxw5EJdrrT+GJD7wNjeHO65/t0X5hk8h6q6a6o\nFv5x1b5ma1Zr/DrXFfbKqi9HS0YpLIL8W/dkLUoRXrPoQlINcYE65MaaWFW8dC8b\nC0IxgHBBZQMTIV3RTvqL/nJRRRdIvtepUh0RJgD4LbtwY5II/+qYPMGzFn8QWGyl\nj02RSadwMrhKSJDw4HhQQF3txGXKljeMhItReGyz8ijM+LCPDxfGfsZXEfhCJf3/\nAGiwxVN/AgMBAAECggEACpjr3Q5Ww+bKyDlss2UvLEge7hQFzCoGGvBBmXjq2S5M\ng1NA8mb7gicDbOXFsmdQcODoiHQaZsWbhG2Z2fR1RxpYx+netwLSp9T5rVm/WN5Z\ncYS9YeH1OFvY4Wjpb59PR5b5xmbUNAR8VoKY4r49gz3HogCFC7ZHGi7TxkJhmIpJ\nq5JJK94jKfXeVddV2s71e4hUeFOSlUkOiDLbZPi69a7bBAeUu5slBeEwTYjPL3I9\nfhr64LuTxNATRWvvClMn8Dft2d8lwbZrXCnB4PmiW9MZIvcBIeQfQS2mgSerJKTy\ny1Ig2WTZcgESnULCpkCrLG5AFJhoBr3nUhtuuSecnQKBgQDo8sgxd6ntHZhu3MKD\nYBiqiQBf0SKa9gGqcjlvzit72U32El6QXFLzKilPyW2A0EHxnfLPBjiEEIx50ao/\nzo53IVH0HLSmnV5v9hG37qljg2Hdcm8UydVlYKlGH+bwQLrcqVkU1PgRgz2OnvRg\nf89joKYrqTldFQ8v2f32rAPFlQKBgQDjwnV49Dpn0MLc582ZNNoBG90FkmEmicIA\n7GXFuEtH7vnG867IaoFPJr/cXqR+p57MfM9hzfZF4TuCi+hxdfnz2i1ITgfaQz+D\npmns6V1jcqjMI+8FM5sQNWmxrJcltvPCdJrOw6GAA+B1PcNqjyrQ3yCgY8jGoeBL\nUDqB/FPHwwKBgGBPwKVzLDZ0/gkYDPP0Tz5y1kzHUt9uxtGJ2GV5gFD8T1dl0OMu\nyLzwuZPbXALeF+WlwDYIBGXV0b6sCQ/Ifu6SQCgFlkss1VbFDh5V9oLGVzgPkA2w\nRSJdDJ+JoRnEKX4CJmqOguH6uQC2h6M+NKikSw/SL31kr5rBLldGV2jhAoGATOFV\nGfEGzghP3pV4dyC5/enT34+br5CMphcl+2nML4nhUmDrPMeGwpsH5HEmAYK/PbNb\npV4KpWfz2Is1eScjqkaZRnDggbJ1fBDubIQRfAI2LEJs6kqTKxN8i/cARkDNY3RM\n1UJ//2BPogOpNQ0CnOLUdo94NGRr+8AnH7124lUCgYEAutBTO8KRbB6ZyNBq9xqv\n3FE6lIBfOUcT0QqYK5oSKuAcSoh9ppRLc6jKa5D929gClK6nkra9EzA8ZhYXW6Xb\n8qAaqS4Y4OW3fpOpXGzURKe/YTDEHGRdrHcGlrzGtIbGyNscATaf2mQ3dvlSw4PO\nPoE8wEmCpQ5B/u4ezxxVKIc=\n-----END PRIVATE KEY-----\n',
//   'client_email': 'firebase-adminsdk-a8zyf@transit-1538616739451.iam.gserviceaccount.com',
//   'client_id': '113398099249819846789',
//   'auth_uri': 'https://accounts.google.com/o/oauth2/auth',
//   'token_uri': 'https://oauth2.googleapis.com/token',
//   'auth_provider_x509_cert_url': 'https://www.googleapis.com/oauth2/v1/certs',
//   'client_x509_cert_url': 'https://www.googleapis.com/robot/v1/metadata/x509/firebase-adminsdk-a8zyf%40transit-1538616739451.iam.gserviceaccount.com'
// }
// staging
// export default {
//   apiKey: 'AIzaSyAseIUCt6BHNr8gT-DzQndckO_3GS7118U',
//   authDomain: 'transit-1538616739451.firebaseapp.com',
//   databaseURL: 'https://transit-1538616739451.firebaseio.com',
//   projectId: 'transit-1538616739451',
//   storageBucket: 'transit-1538616739451.appspot.com',
//   messagingSenderId: '968139152603',
//   appId: '1:968139152603:web:95679916fd7833c1'
// }
// prod
export default {
  apiKey: 'AIzaSyAcSHG9cVqVExOjng4rBbr_Lller6mM_cc',
  authDomain: 'restaurant-app-3a7b0.firebaseapp.com',
  databaseURL: 'https://restaurant-app-3a7b0.firebaseio.com',
  projectId: 'restaurant-app-3a7b0',
  storageBucket: 'restaurant-app-3a7b0.appspot.com',
  messagingSenderId: '372669475230',
  appId: '1:372669475230:web:883ac63fa3085e22'
}



// WEBPACK FOOTER //
// ./src/components/firebaseConfig.js